import { Trans, useLingui } from '@lingui/react/macro';
import { Checkmark } from '@remarkable/ark-icons';
import { Typography } from '@remarkable/ark-web';

import { ComponentLocations } from 'src/analytics/trackingTypes';
import { Button, CardContent, Sheet } from 'src/components';
import { AppPage } from 'src/components/AppPage';
import { Link2 } from 'src/components/Link2';
import { cn } from 'src/utils/classNamesHelper';
import { URLS } from 'src/utils/urls/urls';

export const SetupComplete = ({
  secondDevice = false,
  className,
}: {
  secondDevice: boolean;
  className?: string;
}) => {
  const { t } = useLingui();
  return (
    <AppPage.Container>
      <AppPage.Content className="max-w-ll pt-24 lm:pt-64">
        <Sheet className={cn('mb-32 flex flex-col gap-32', className)}>
          <CardContent className="flex flex-col gap-16">
            <Typography variant="heading-md">
              <Trans>You&apos;re all set</Trans>
            </Typography>
            <Typography variant="body-md">
              {!secondDevice ? (
                <span>
                  <Trans>
                    Setup completed successfully. At{' '}
                    <Link2
                      inline
                      to={URLS.HOME}
                      className="text-pen-blue hover:no-underline"
                      componentLocation={
                        ComponentLocations.SETUP.SETUP_COMPLETE
                      }
                    >
                      {' '}
                      my.remarkable.com
                    </Link2>{' '}
                    you can manage your reMarkable universe and discover
                    features to improve your workflow.
                  </Trans>
                </span>
              ) : (
                <Trans>
                  Your content will now sync to the cloud automatically, and
                  across devices, as long as you&apos;re connected to Wi-Fi.
                </Trans>
              )}
            </Typography>
          </CardContent>
          <Button
            className="ml-auto w-full lm:w-fit"
            variant="tertiary"
            as="a"
            to={URLS.HOME}
            analytics={{
              location: ComponentLocations.SETUP.SETUP_COMPLETE,
              text: t`Close`,
              action: 'close setup',
            }}
          >
            <span>
              <Trans>Close</Trans>
            </span>
            <Checkmark />
          </Button>
        </Sheet>
      </AppPage.Content>
    </AppPage.Container>
  );
};
